import Constants from '../constants/index'
import xhr from 'live/services/xhr'

export const TIMELINE_URL = '/services/plugin-annotations/timeline'
export const USER_SETTINGS_TIMELINE_CONFIG_URL = '/rest/me/settings/timeline/config/dashboard'

export function applyTimelineConfig (config) {
    return {
        type: Constants.APPLY_TIMELINE_CONFIG,
        timelineConfig: config
    }
}

export function applyUserTimelineVisible (visible) {
    return {
        type: Constants.APPLY_USER_TIMELINE_CONFIG,
        userTimelineVisible: visible
    }
}
export function fetchTimelineConfig (dashboardId) {
    return dispatch => xhr.get(`${TIMELINE_URL}/config/${dashboardId}`)
        .then(res => {
            dispatch(applyTimelineConfig(res.data))
        }).catch(error => {
            dispatch({
                type: Constants.SET_ERROR,
                error: error.message
            })
        })
}

export function saveTimelineConfig (dashboardId, config) {
    return dispatch => {
        return xhr.post(`${TIMELINE_URL}/config/${dashboardId}`, config)
            .then(res => {
                dispatch(applyTimelineConfig(config))
            }).catch(error => {
                dispatch({
                    type: Constants.SET_ERROR,
                    error: error.message
                })
            })
    }
}

export function saveUserTimelineVisibility (dashboardId, visible) {
    return dispatch => {
        // Optmistic show/hide timeline
        dispatch(applyUserTimelineVisible(visible))

        return xhr.post(`${USER_SETTINGS_TIMELINE_CONFIG_URL}/${dashboardId}`, {userTimelineVisible: visible})
            .catch(error => {
                dispatch({
                    type: Constants.SET_ERROR,
                    error: error.message
                })
            })
    }
}

export function fetchUserTimelineVisibility (dashboardId) {
    return dispatch => xhr.get(`${USER_SETTINGS_TIMELINE_CONFIG_URL}/${dashboardId}`)
        .then(res => {
            const data = res.data
            // If user didnt set a value for userTimelineVisible set default = true.
            const userTimelineVisible = !data || data.userTimelineVisible

            dispatch(applyUserTimelineVisible(userTimelineVisible))
        }).catch(error => {
            dispatch({
                type: Constants.SET_ERROR,
                error: error.message
            })
        })
}
